<template>
  <b-pagination
    :value="currentPage"
    :total-rows="jobsCount"
    :per-page="limitPerPage"
    size="sm"
    hide-goto-end-buttons
    last-number
    :limit="2"
    class="mb-0"
    @change="handlePagination"
  >
    <template #prev-text>
      <b-icon icon="chevron-left"></b-icon>
    </template>
    <template #next-text>
      <b-icon icon="chevron-right"></b-icon>
    </template>
  </b-pagination>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Pagination extends Vue {
  @Prop({ required: true }) readonly jobsCount!: number;

  @Prop({ required: true }) readonly currentPage!: number;

  @Prop({ required: true }) readonly limitPerPage!: number;

  handlePagination(page: number) {
    this.$emit('handle-pagination', page);
  }
}
</script>
